module.exports = __webpack_public_path__ + "img/vr_m_4.5eaebab6.jpg";